/**
 * MediaPipe Face Landmarker indices (478 points: 468 mesh + 10 iris).
 * "LEFT"/"RIGHT" are the *subject's* left/right (MediaPipe convention).
 * In an un-mirrored camera image the subject's right eye appears on the image's left.
 */
export const FACE_LM = {
  COUNT: 478,
  MESH_COUNT: 468,

  NOSE_TIP: 1,
  NOSE_BOTTOM: 2,
  NOSE_BRIDGE: 168, // between the eyes — glasses bridge / pads
  NOSE_BRIDGE_LOW: 6,
  NOSE_BRIDGE_MID: 197,
  FOREHEAD: 10, // hairline / top of face mesh
  FOREHEAD_MID: 151,
  GLABELLA: 9,
  CHIN: 152,
  UPPER_LIP: 0,
  LOWER_LIP: 17,
  MOUTH_LEFT: 291,
  MOUTH_RIGHT: 61,

  RIGHT_EYE_OUTER: 33,
  RIGHT_EYE_INNER: 133,
  RIGHT_EYE_TOP: 159,
  RIGHT_EYE_BOTTOM: 145,
  LEFT_EYE_INNER: 362,
  LEFT_EYE_OUTER: 263,
  LEFT_EYE_TOP: 386,
  LEFT_EYE_BOTTOM: 374,

  RIGHT_IRIS_CENTER: 468,
  LEFT_IRIS_CENTER: 473,

  RIGHT_EYEBROW_OUTER: 70,
  RIGHT_EYEBROW_INNER: 107,
  LEFT_EYEBROW_INNER: 336,
  LEFT_EYEBROW_OUTER: 300,

  /** Tragus / ear-canal region at the edge of the mesh — temple tips of glasses rest here. */
  RIGHT_EAR: 234,
  LEFT_EAR: 454,
  /** Just below the tragus — earring hook approximations. */
  RIGHT_EAR_LOBE: 132,
  LEFT_EAR_LOBE: 361,
  RIGHT_EAR_LOBE_ALT: 177,
  LEFT_EAR_LOBE_ALT: 401,

  RIGHT_CHEEK: 50,
  LEFT_CHEEK: 280,
  RIGHT_TEMPLE: 127,
  LEFT_TEMPLE: 356,
  RIGHT_JAW: 172,
  LEFT_JAW: 397,
  RIGHT_NOSTRIL: 98,
  LEFT_NOSTRIL: 327,
} as const

/** MediaPipe Hand Landmarker indices (21 points). */
export const HAND_LM = {
  COUNT: 21,
  WRIST: 0,
  THUMB_CMC: 1, THUMB_MCP: 2, THUMB_IP: 3, THUMB_TIP: 4,
  INDEX_MCP: 5, INDEX_PIP: 6, INDEX_DIP: 7, INDEX_TIP: 8,
  MIDDLE_MCP: 9, MIDDLE_PIP: 10, MIDDLE_DIP: 11, MIDDLE_TIP: 12,
  RING_MCP: 13, RING_PIP: 14, RING_DIP: 15, RING_TIP: 16,
  PINKY_MCP: 17, PINKY_PIP: 18, PINKY_DIP: 19, PINKY_TIP: 20,
} as const

/** MediaPipe Pose Landmarker indices (33 points) — subset we use. */
export const POSE_LM = {
  COUNT: 33,
  NOSE: 0,
  LEFT_EYE: 2, RIGHT_EYE: 5,
  LEFT_EAR: 7, RIGHT_EAR: 8,
  LEFT_SHOULDER: 11, RIGHT_SHOULDER: 12,
  LEFT_ELBOW: 13, RIGHT_ELBOW: 14,
  LEFT_WRIST: 15, RIGHT_WRIST: 16,
  LEFT_PINKY: 17, RIGHT_PINKY: 18,
  LEFT_INDEX: 19, RIGHT_INDEX: 20,
  LEFT_THUMB: 21, RIGHT_THUMB: 22,
  LEFT_HIP: 23, RIGHT_HIP: 24,
} as const

/** Average adult inter-pupillary distance in cm (used for real-world scale). */
export const AVERAGE_IPD_CM = 6.3
